import { Place } from './../itineray.model';
import { EventEmitter, Output } from '@angular/core';
import { LatLngPickerDialogComponent, LatLngPickerDialogData } from './../lat-lng-picker-dialog/lat-lng-picker-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FocusMonitor } from '@angular/cdk/a11y';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, ElementRef, Input, OnDestroy, Optional, Self } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { Subject } from 'rxjs';

import * as firebase from "firebase/app";
import "firebase/firestore";

@Component({
  selector: 'app-lat-lng-input',
  templateUrl: './lat-lng-input.component.html',
  styleUrls: ['./lat-lng-input.component.css'],
  providers: [{ provide: MatFormFieldControl, useExisting: LatLngInputComponent }],
  host: {
    '[class.example-floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class LatLngInputComponent implements ControlValueAccessor, MatFormFieldControl<Place>, OnDestroy {

  static nextId = 0;

  place: Place;

  @Output()
  valueChange = new EventEmitter<Place>();

  @Input()
  searchText: string;

  stateChanges = new Subject<void>();
  focused = false;
  errorState = false;
  controlType = 'lat-lng-input';
  id = `lat-lng-input-${LatLngInputComponent.nextId++}`;
  describedBy = '';
  onChange = (_: any) => { };
  onTouched = () => { };



  get empty() {
    return !this.place;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): Place | null {
    return this.place;
  }
  set value(place: Place | null) {
    this.place = place;
  }

  constructor(
    private _focusMonitor: FocusMonitor,
    private _elementRef: ElementRef<HTMLElement>,
    private dialog: MatDialog,
    @Optional() @Self() public ngControl: NgControl) {

    _focusMonitor.monitor(_elementRef, true).subscribe(origin => {
      if (this.focused && !origin) {
        this.onTouched();
      }
      this.focused = !!origin;
      this.stateChanges.next();
    });

    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this._focusMonitor.stopMonitoring(this._elementRef);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {
    if (!this.disabled) {
      this.openPicker();
    }
  }

  writeValue(place: Place | null): void {
    this.place = place;
    this.valueChange.emit(this.place);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  openPicker() {
    const data: LatLngPickerDialogData = {
      place: this.value,
      searchText: this.searchText
    }
    const dialogRef = this.dialog.open(LatLngPickerDialogComponent, {
      width: '80%',
      data
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.writeValue(result);
      } else {
        if (result === null) {
          this.writeValue(null);
        }
      }
    });

  }

}
